import { render, staticRenderFns } from "./co-feed.vue?vue&type=template&id=1ec35a96&scoped=true&"
import script from "./co-feed.vue?vue&type=script&lang=ts&"
export * from "./co-feed.vue?vue&type=script&lang=ts&"
import style0 from "./co-feed.vue?vue&type=style&index=0&id=1ec35a96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec35a96",
  null
  
)

export default component.exports